import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { ValueProps } from "./components/ValueProps";
import { Pricing } from "./components/Pricing";
import { Policy } from "./components/Policy";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";

const Home = () => {
  return (
    <div className="App noise-layer relative">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ValueProps />
        <Pricing />
        <Policy />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
